module.exports = __webpack_public_path__ + "static/media/ta-02.2f798eda.png";